import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { UserService } from 'app/core/user/user.service';
import { AppService } from 'app/app.service';
@Injectable()
export class AuthService {
    private _authenticated: boolean = false;

    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        private _userService: UserService,
        private appService: AppService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for access token
     */
    set accessToken(token: string) {
        localStorage.setItem('accessToken', token);
    }

    get accessToken(): string {
        return localStorage.getItem('accessToken') ?? '';
    }


    verifyOTP(id: string, otp: string): Observable<any> {
        return this._httpClient.post(this.appService.getApiUrl() + 'user/verify-otp', { otp, id }).pipe(
            switchMap((response: any) => {
                if (response.user) {
                    localStorage.setItem('user', JSON.stringify(response.user));
                }

                // Store the access/refresh token in the local storage
                this.accessToken = response?.accessToken ? response?.accessToken : '';
                // this.refreshToken = response.tokens.refresh.token;
                // Set the authenticated flag to true
                this._authenticated = true;
                this._userService.user = response.user;
                // Return a new observable with the response
                return of(response);
            })
        );
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Forgot password
     *
     * @param email
     */
    forgotPassword(email: string): Observable<any> {
        return this._httpClient.post(this.appService.getApiUrl() + 'user/forgot-password', { email });
    }

    /**
     * Reset password
     *
     * @param password
     */
    resetPassword(payload: any): Observable<any> {
        return this._httpClient.post(this.appService.getApiUrl() + 'user/reset-password', payload);
    }

    /**
     * Sign in
     *
     * @param credentials
     */

    //  loginUser(userLoginData: any) {
    //     return this.http.post(
    //       this.appSerivce.getApiUrl() + 'user/login',
    //       userLoginData
    //     );
    //   }
    signIn(credentials: { email: string; password: string }): Observable<any> {
        // Throw error, if the user is already logged in
        if (this._authenticated) {
            return throwError('User is already logged in.');
        }

        return this._httpClient.post(this.appService.getApiUrl() + 'user/login', credentials).pipe(
            // return this._httpClient.post('api/auth/sign-in', credentials).pipe(
            switchMap((response: any) => {
                // console.log(response)
                // localStorage.setItem('user', JSON.stringify(response.user));
                // // Store the access token in the local storage
                // this.accessToken = response.token;

                // response.accountStatus
                // // Set the authenticated flag to true
                // this._authenticated = true;

                // // Store the user on the user service
                // const user = {
                //     id: response.id,
                //     name: response.name,
                //     email: response.email,
                //     avatar: response?.avatar,
                //     status: 'online',
                //     // designation: response?.designation[0].name,
                //    // userType: response.userType.name,
                //     team: response?.teams,
                // }
                // this._userService.user = user;

                // Return a new observable with the response
                return of(response);
            })
        );
    }


    /**
     * Sign in using the access token
     */
    signInUsingToken(): Observable<any> {
        // Renew token
        return this._httpClient.post('api/auth/refresh-access-token', {
            accessToken: this.accessToken
        }).pipe(
            catchError(() =>

                // Return false
                of(false)
            ),
            switchMap((response: any) => {

                // Store the access token in the local storage
                this.accessToken = response.accessToken;

                // Set the authenticated flag to true
                this._authenticated = true;

                // Store the user on the user service
                this._userService.user = response.user;

                // Return true
                return of(true);
            })
        );
    }

    /**
     * Sign out
     */
    signOut(): Observable<any> {
        // Remove the access token from the local storage
        localStorage.removeItem('accessToken');

        // Set the authenticated flag to false
        this._authenticated = false;

        // Return the observable
        return of(true);
    }

    /**
     * Sign up
     *
     * @param user
     */
    signUp(user: { name: string; email: string; password: string; }): Observable<any> {
        return this._httpClient.post(this.appService.getApiUrl() + 'user/signup', user);
    }

    /**
     * Unlock session
     *
     * @param credentials
     */
    unlockSession(credentials: { email: string; password: string }): Observable<any> {
        return this._httpClient.post('api/auth/unlock-session', credentials);
    }

    /**
     * Check the authentication status
     */
    check(): Observable<boolean> {
        // Check if the user is logged in
        if (this._authenticated) {
            return of(true);
        }

        // Check the access token availability
        if (!this.accessToken) {
            return of(false);
        }
        return of(true); //Delete it

        // Check the access token expire date
        // if (AuthUtils.isTokenExpired(this.accessToken) )
        // {
        //     return of(false);
        // }

        // If the access token exists and it didn't expire, sign in using it
        // return this.signInUsingToken();
    }
    getPermission(Userdata) {
        console.log(Userdata)
        return this._httpClient.post(
            this.appService.getApiUrl() + 'userTypeRole/getPermission',
            Userdata
        );
    }

    getAllPermissionByCategory(Userdata) {
        console.log(Userdata)
        return this._httpClient.post(
            this.appService.getApiUrl() + 'userTypeRole/getPermissionbycategory',
            Userdata
        );
    }

    resetPasswordWorkingPartner(payload: any): Observable<any> {
        return this._httpClient.post(this.appService.getApiUrl() + 'employeeProfile/change-password', payload);
    }

}
